import { Box } from "@vinomofo/components";

import { ContentTile, ContentTileProps } from "../content-tile";

export type TwoUpBlockProps = {
  tiles: Array<ContentTileProps>;
};

export const TwoUpBlock = ({ tiles }: TwoUpBlockProps): JSX.Element => {
  return (
    <Box
      display="grid"
      gridGap={[20, 30, 40]}
      gridTemplateColumns={["1fr", "1fr 1fr"]}
    >
      {tiles.map(({ title, image, primaryCta, bodyText }, i) => (
        <ContentTile
          key={i}
          title={title}
          image={image}
          primaryCta={primaryCta}
          bodyText={bodyText}
        />
      ))}
    </Box>
  );
};
